'use client'

import { Switch as SwitchBase } from '@/components/ui/switch'

import { cn, isFieldInvalid } from '@/utils'

import { FieldWrapper } from './field-wrapper'
import { useFieldContext } from './form'

type SwitchProps = {
  activeText?: string
  danger?: boolean
  inactiveText?: string
  label?: React.ReactNode
  labelClassName?: string
  required?: boolean
  wrapperClassName?: string
} & React.ComponentProps<typeof SwitchBase>

export const Switch = ({
  activeText,
  checked,
  className,
  danger: _danger = true,
  inactiveText,
  label,
  labelClassName,
  onCheckedChange,
  required,
  wrapperClassName,
  ...props
}: SwitchProps) => {
  const field = useFieldContext<boolean | number | string | undefined>()
  const isInvalid = isFieldInvalid(field)
  void _danger
  const resolvedChecked =
    typeof checked === 'boolean'
      ? checked
      : typeof field.state.value === 'string'
        ? field.state.value === '1' || field.state.value === 'true'
        : Boolean(field.state.value)

  return (
    <FieldWrapper
      classNames={{ label: labelClassName, wrapper: wrapperClassName }}
      field={field}
      label={label}
      required={required}
    >
      <div className="flex items-center gap-3">
        <SwitchBase
          checked={resolvedChecked}
          className={cn(className)}
          data-invalid={isInvalid || undefined}
          id={field.name}
          name={field.name}
          onBlur={field.handleBlur}
          onCheckedChange={(nextChecked) => {
            if (onCheckedChange) {
              onCheckedChange(nextChecked)
              return
            }

            field.handleChange(nextChecked)
          }}
          {...props}
        />
        {(activeText || inactiveText) && (
          <span className={cn('text-sm font-medium')}>
            {resolvedChecked ? activeText : inactiveText}
          </span>
        )}
      </div>
    </FieldWrapper>
  )
}
